/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {I18NextErrorInterceptor as ɵa} from './i18next-error.interceptor';